import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { theme } from 'connect-dot-com-ui/components/Theme';
import UIHeader from 'UIComponents/layout/UIHeader';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import HR from 'UIComponents/elements/HR';
import { useUserByAuth, useClaimProfile } from '../features/users/userQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrl } from 'hubspot-url-utils';
import ClaimProfile from '../features/users/components/ClaimProfile';
import AvatarViewer from '../features/avatar/components/AvatarViewer';
import UIFlex from 'UIComponents/layout/UIFlex'; // @ts-expect-error cannot find module

import logoUrl from 'bender-url!../../img/logo/connect-full-logo-color.svg'; // @ts-expect-error cannot find module

import iconUrl from 'bender-url!../../img/logo/connect-infinity-icon-color.svg';
import { hubspotEditPagePaths } from '../utils/urls';
import SignupLogin from './SignupLogin';
import { useMediaQuery } from '../utils/hooks';
import { useUserInfo } from '../features/auth/authQueries';
const ConnectHeader = styled(UIHeader).withConfig({
  displayName: "Header__ConnectHeader",
  componentId: "sc-1o62fwz-0"
})(["& > div{width:100%;max-width:1200px;margin:auto;}@media (max-width:", "){padding-left:12px;padding-right:12px;}"], props => props.theme.sizes.GRID_BREAKPOINT_SMALL);

const Header = () => {
  const {
    userInfo: hubspotUser
  } = useUserInfo();
  const {
    user
  } = useUserByAuth();
  const {
    hasClaimedProfile,
    fetchClaimError,
    claimLoading
  } = useClaimProfile();
  const screenLarge = useMediaQuery(`(min-width: ${theme.sizes.GRID_BREAKPOINT_SMALL})`);

  const title = /*#__PURE__*/_jsx(UILink, {
    href: hubspotEditPagePaths.directory(),
    use: "unstyled",
    children: /*#__PURE__*/_jsx("img", {
      src: screenLarge ? logoUrl : iconUrl,
      height: "29px"
    })
  });

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(ConnectHeader, {
      className: "m-bottom-0",
      headingLevel: "h2",
      title: title,
      children: fetchClaimError || claimLoading ? null : !hubspotUser || !hubspotUser.email ? /*#__PURE__*/_jsx(SignupLogin, {}) : !hasClaimedProfile ? /*#__PURE__*/_jsx(ClaimProfile, {}) : user ? /*#__PURE__*/_jsx(UIDropdown, {
        "data-test-id": "profile-dropdown",
        arrowSize: "small",
        buttonUse: "unstyled",
        buttonText: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(AvatarViewer, {
            size: "sm",
            avatarHash: user.avatarHash,
            lastUpdated: user.avatarLastUpdated
          }), /*#__PURE__*/_jsx("span", {
            className: "m-left-3",
            children: user.displayName
          })]
        }),
        placement: "bottom left",
        children: /*#__PURE__*/_jsxs(UIList, {
          children: [/*#__PURE__*/_jsx(UILink, {
            href: hubspotEditPagePaths.user(user.userName),
            "data-test-id": "view-profile-link",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.viewProfile"
            })
          }), /*#__PURE__*/_jsx(UILink, {
            href: hubspotEditPagePaths.edit(),
            "data-test-id": "edit-profile-link",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.editProfile"
            })
          }), /*#__PURE__*/_jsx(UILink, {
            href: `${getFullUrl('app')}/user-preferences/profile`,
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.accountSettings"
            })
          }), /*#__PURE__*/_jsx(HR, {
            distance: "flush"
          }), /*#__PURE__*/_jsx(UILink, {
            href: `${getFullUrl('app')}/login-api/v1/logout/all?redirectUrl=${encodeURIComponent(window.location.href)}`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.signOut"
            })
          })]
        })
      }) : null
    })
  });
};

export default Header;